import axios from "axios";
import { BASE_TEST_URL, BASE_URL, EMAILPASSWORDERROR, FAILED, FIELD_EMPTY, INVALIDBILL, INVALIDSMSOTP, IS_DEV, NODATA, NULLDATA, SUCCESS, USERNOTFOUND } from "../Utils/constant";
import { isEmpty, printDebugLog } from "../Utils/utils";
import { toast } from "react-toastify";



const validateError = (response, errSts, errorMsg, allowedNoDataErrorMsg = false) => {
    if (errSts === SUCCESS) {
        return response;
    } else if (errSts === INVALIDBILL) {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Invalid Bill" : errorMsg}</p>)
    } else if (errSts === INVALIDSMSOTP) {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Invalid Otp</p>)
    } else if (errSts === FAILED) {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Failed" : errorMsg}</p>);
        const error = new Error(isEmpty(errorMsg) ? "Failed to send/request data" : errorMsg); // Create an Error instance
        error.code = errSts; // Attach custom properties
        throw error; // Throw the Error
    } else if (errSts === NULLDATA) {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Unexpected Request! Contact SNP Admin" : errorMsg}</p>);
    } else if (errSts === FIELD_EMPTY) {
        if (IS_DEV)
            toast.warning(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Missing Fields!Contact SNP Admin" : errorMsg}</p>);
        else
            toast.warning(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{"Some Key Not Available!\nContact SNP Admin"}</p>);
    } else if (errSts === NODATA) {
        if (allowedNoDataErrorMsg) {
            toast.error(
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Internal Error Try Again" : errorMsg}</p>);
        } else {
            console.warn("NODATA: errorMsg : ", errorMsg);
        }
    } else if (errSts === EMAILPASSWORDERROR) {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Email & Password is wrong</p>);
    } else if (errSts === USERNOTFOUND) {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>You're not registered with us.</p>);
    } else {
        toast.error(
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{isEmpty(errorMsg) ? "Internal Error Try Again" : errorMsg}</p>);
    }
    const error = new Error(isEmpty(errorMsg) ? "Network Issue (Unexpected code) " : ""); // Create an Error instance
    error.code = errSts; // Attach custom properties
    throw error; // Throw the Error
}

// Create an instance with defaults
const snpAxios = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 30000,
});


snpAxios.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor (optional)
snpAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);



export const GET = async (url, config = {}) => {
    try {
        const response = await snpAxios.get(url, config);
        printDebugLog(`${url}`, response.data);
        const validateErrorResponse = validateError(response, response.data.status, response.data.errorMessage, true);
        return validateErrorResponse.data.jcJson;
    } catch (error) {
        console.error("GET error:", error);
        throw error?.response?.data || error.message
    }
};

export const GETWITHOUTNODATA = async (url, config = {}) => {
    try {
        const response = await snpAxios.get(url, config);
        printDebugLog(`${url}`, response.data);
        const validateErrorResponse = validateError(response, response.data.status, response.data.errorMessage, false);
        return validateErrorResponse.data.jcJson;
    } catch (error) {
        console.error("GET error:", error);
        throw error?.response?.data || error.message
    }
};

export const GETWITHOUTJSON = async (url, config = {}) => {
    try {
        const response = await snpAxios.get(url, config);
        printDebugLog(`${url}`, response.data);
        return response?.data ?? null;
    } catch (error) {
        console.error("GETWITHOUTJSON error:", error);
        throw error?.response?.data || error.message
    }
};

export const POST = async (url, payLoad = {}, config = {}) => {
    try {
        const response = await snpAxios.post(url, payLoad, config);
        printDebugLog(`${url}`, response.data);
        const validateErrorResponse = validateError(response, response.data.status, response.data.errorMessage, true);
        return validateErrorResponse.data.jcJson;
    } catch (error) {
        console.error("POST error:", error);
        throw error?.response?.data || error.message
    }
};


export const POSTWITHOUTVALIDATE = async (url, payLoad = {}, config = {}) => {
    try {
        const response = await snpAxios.post(url, payLoad, config);
        printDebugLog(`${url}`, response.data);
        return response.data;
    } catch (error) {
        console.error("POSTWITHOUTVALIDATE error:", error);
        //throw error?.response?.data || error.message
    }
    return null;
};

export const GETWITHOUTVALIDATE = async (url, config = {}) => {
    try {
        const response = await snpAxios.get(url, config);
        printDebugLog(`${url}`, response.data);
        return response.data;
    } catch (error) {
        console.error("GETWITHOUTVALIDATE error:", error);
        //throw error?.response?.data || error.message
    }
    return null;
};

export const GetWithResponse = async (url, config = {}) => {
    try {
        const response = await snpAxios.get(url, config);
        printDebugLog(`${url}`, response);
        return response;
    } catch (error) {
        console.error("GetWithResponse error:", error);
        //throw error?.response?.data || error.message
    }
    return null;
};


// Test Axios Framework


const testAxios = axios.create({
    baseURL: BASE_TEST_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 300000,
});

testAxios.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor (optional)
testAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);

export const TESTGET = async (url, config = {}) => {
    try {
        const response = await testAxios.get(url, config);
        printDebugLog(`${url}`, response.data);
        const validateErrorResponse = validateError(response, response.data.status, response.data.errorMessage, true);
        return validateErrorResponse.data.jcJson;
    } catch (error) {
        console.error("GET error:", error);
        throw error?.response?.data || error.message
    }
};

export const TESTGETWITHOUTJSON = async (url, config = {}) => {
    try {
        const response = await testAxios.get(url, config);
        printDebugLog(`${url}`, response.data);
        const validateErrorResponse = validateError(response, response.data, "");
        return validateErrorResponse.data;
    } catch (error) {
        console.error("GETWITHOUTJSON error:", error);
        throw error?.response?.data || error.message
    }
};

export const TESTPOST = async (url, payLoad = {}, config = {}) => {
    try {
        const response = await testAxios.post(url, payLoad, config);
        printDebugLog(`${url}`, response.data);
        const validateErrorResponse = validateError(response, response.data.status, response.data.errorMessage, true);
        return validateErrorResponse.data.jcJson;
    } catch (error) {
        console.error("POST error:", error);
        throw error?.response?.data || error.message
    }
};
